var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
// TODO: remove duplicate cookie library from bundle
import cookies from 'js-cookie';
import topDomain from '@segment/top-domain';
import { EventEmitter } from 'events';
var DEFAULT_COOKIE_NAME = 'tracking-preferences';
var COOKIE_DEFAULT_EXPIRES = 365;
// TODO: harden against invalid cookies
// TODO: harden against different versions of cookies
export function loadPreferences(cookieName) {
  var preferences = cookies.getJSON(cookieName || DEFAULT_COOKIE_NAME);
  if (!preferences) {
    return {};
  }
  return {
    destinationPreferences: preferences.destinations,
    customPreferences: preferences.custom
  };
}
var emitter = new EventEmitter();
/**
 * Subscribes to consent preferences changing over time and returns
 * a cleanup function that can be invoked to remove the instantiated listener.
 *
 * @param listener a function to be invoked when ConsentPreferences are saved
 */
export function onPreferencesSaved(listener) {
  emitter.on('preferencesSaved', listener);
  return function () {
    return emitter.off('preferencesSaved', listener);
  };
}
export function savePreferences(_a) {
  var destinationPreferences = _a.destinationPreferences,
    customPreferences = _a.customPreferences,
    cookieDomain = _a.cookieDomain,
    cookieName = _a.cookieName,
    cookieExpires = _a.cookieExpires,
    _b = _a.cookieAttributes,
    cookieAttributes = _b === void 0 ? {} : _b;
  var wd = window;
  if (wd.analytics) {
    wd.analytics.identify({
      destinationTrackingPreferences: destinationPreferences,
      customTrackingPreferences: customPreferences
    });
  }
  var domain = cookieDomain || topDomain(window.location.href);
  var expires = cookieExpires || COOKIE_DEFAULT_EXPIRES;
  var value = {
    version: 1,
    destinations: destinationPreferences,
    custom: customPreferences
  };
  cookies.set(cookieName || DEFAULT_COOKIE_NAME, value, __assign({
    expires: expires,
    domain: domain
  }, cookieAttributes));
  emitter.emit('preferencesSaved', {
    destinationPreferences: destinationPreferences,
    customPreferences: customPreferences
  });
}